const languagesActionTypes =  {    
    RETRIEVED_SITESETTINGS_LANGUAGE_SETTINGS: "RETRIEVED_SITESETTINGS_LANGUAGE_SETTINGS",
    SITESETTINGS_LANGUAGE_SETTINGS_CLIENT_MODIFIED: "SITESETTINGS_LANGUAGE_SETTINGS_CLIENT_MODIFIED",
    UPDATED_SITESETTINGS_LANGUAGE_SETTINGS: "UPDATED_SITESETTINGS_LANGUAGE_SETTINGS",
    RETRIEVED_SITESETTINGS_LANGUAGES: "RETRIEVED_SITESETTINGS_LANGUAGES",
    RETRIEVED_SITESETTINGS_LANGUAGE: "RETRIEVED_SITESETTINGS_LANGUAGE",
    RETRIEVED_SITESETTINGS_ALL_LANGUAGES: "RETRIEVED_SITESETTINGS_ALL_LANGUAGES",
    SITESETTINGS_LANGUAGE_CLIENT_MODIFIED: "SITESETTINGS_LANGUAGE_CLIENT_MODIFIED",
    CANCELED_SITESETTINGS_LANGUAGE_CLIENT_MODIFIED: "CANCELED_SITESETTINGS_LANGUAGE_CLIENT_MODIFIED",
    CREATED_SITESETTINGS_LANGUAGE: "CREATED_SITESETTINGS_LANGUAGE",
    VERIFIED_SITESETTINGS_LANGUAGE_RESOURCE_FILES: "VERIFIED_SITESETTINGS_LANGUAGE_RESOURCE_FILES",
    RETRIEVED_SITESETTINGS_LANGUAGE_PACK_MODULE_LIST: "RETRIEVED_SITESETTINGS_LANGUAGE_PACK_MODULE_LIST",
    CREATED_SITESETTINGS_LANGUAGE_PACK: "CREATED_SITESETTINGS_LANGUAGE_PACK",
    RETRIEVED_SITESETTINGS_LANGUAGE_ROLE_GROUPS: "RETRIEVED_SITESETTINGS_LANGUAGE_ROLE_GROUPS",
    RETRIEVED_SITESETTINGS_LANGUAGE_ROLES: "RETRIEVED_SITESETTINGS_LANGUAGE_ROLES",
    RETRIEVED_SITESETTINGS_LANGUAGE_PAGES: "RETRIEVED_SITESETTINGS_LANGUAGE_PAGES",
    UPDATED_SITESETTINGS_LANGUAGE: "UPDATED_SITESETTINGS_LANGUAGE",
    UPDATED_SITESETTINGS_LANGUAGE_ROLES: "UPDATED_SITESETTINGS_LANGUAGE_ROLES",
    UPDATED_SITESETTINGS_LANGUAGE_ROLE_SELECTION: "UPDATED_SITESETTINGS_LANGUAGE_ROLE_SELECTION",
    ENABLED_LOCALIZED_CONTENT: "ENABLED_LOCALIZED_CONTENT",
    DISABLED_LOCALIZED_CONTENT: "DISABLED_LOCALIZED_CONTENT",
    DELETED_LANGUAGE_PAGES: "DELETED_LANGUAGE_PAGES",
    PUBLISHED_LOCALIZED_PAGES: "PUBLISHED_LOCALIZED_PAGES"

};
export default languagesActionTypes;
